module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block new",
    on: {
      "click": _vm.addBlock
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d850d66!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/NewBlock.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5d850d66!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/NewBlock.vue
// module chunks = 0